import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    Switch,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import { getRoles, resetRoles } from "../../Redux/RolesSlice/RolesSlice";
import { toast } from "react-toastify";
import { getAllBusiness, resetBusiness } from "../../Redux/BusSlice/BusSlice";
import { useParams } from "react-router-dom";
import {
    CreateUserDocuments,
    getAllUsersWihtoutPage,
    getSingleUsers,
    getUserByBusiness,
    reset,
    ShowUserDocuments,
    updateUser,
} from "../../Redux/UserSlice/UserSlice";
import styled from "styled-components";
import { DocumentScanner } from "@mui/icons-material";

const validationSchema = yup.object({
    name: yup.string("Enter your Name").required(" Name is required "),
    email: yup
        .string("Enter your email")
        .email("Enter a valid email")
        .required("Email is required"),
    ppw: yup.number("Enter your PPW").required(" PPW is required "),
    // phone: yup.number("Enter your Phone").required(" Phone is required "),

    // password: yup
    //   .string("Enter your password")
    //   .min(8, "Password should be of minimum 8 characters length")
    //   .required("Password is required"),
    // password_confirmation: yup
    //   .string("Enter your Confirm Password")
    //   .min(8, "Password should be of minimum 8 characters length")
    //   .required("Confirm Password is required"),
    // business_id: yup
    //   .string("Enter your business")
    //   .required(" Business is required "),
    // parent: yup.string("Enter your Parent").required(" Parent is required "),
});

const EditUsers = () => {
    const dispatch = useDispatch();
    const { id } = useParams();

    ////////////////////
    const { singleUser } = useSelector((state) => state.users);
    const SINGLE_USER = singleUser ? singleUser?.data : "";

    //////////////////////////
    const [roles, setroles] = useState([]);
    const {
        usersByBusiness,
        user_documents,
        isLodaing,
        isError,
        editSuccess,
        massage,
    } = useSelector((state) => state.users);
    const allroles = useSelector((state) => state.roles.roles);
    const { business } = useSelector((state) => state.business);

    const userDocuments = user_documents?.data || [];
    /////////////////////
    const ALL_USER = usersByBusiness?.data || [];
    const ALL_ROLES = allroles?.data || [];
    const ALL_BUSINESS = business?.data?.data || [];

    const getRolseId = SINGLE_USER?.roles?.map((item) => {
        return item.id;
    });

    useEffect(() => {
        const GetAllUsers = async () => {
            await dispatch(getSingleUsers(id));
            await dispatch(ShowUserDocuments(id));
            await dispatch(reset());
        };

        const getAll = async () => {
            await dispatch(getAllUsersWihtoutPage());
            await dispatch(reset());
            await dispatch(getRoles());
            await dispatch(resetRoles());
            await dispatch(getAllBusiness());
            await dispatch(resetBusiness());
        };
        if (id) {
            GetAllUsers();
            getAll();
        }
    }, [id]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setroles(
            // On autofill we get a stringified value.
            typeof value === "string" ? value.split(",") : value,
            getRolseId
        );
    };

    const formik = useFormik({
        initialValues: {
            name: singleUser?.data?.name,
            email: singleUser?.data?.email,
            // password: singleUser?.data?.password,
            // password_confirmation: singleUser?.data?.password_confirmation,
            business_id: Number(singleUser?.data?.business_id),
            parent: singleUser?.data?.parent,
            ppw: singleUser?.data?.ppw,
            phone: singleUser?.data?.phone,
            is_active: Boolean(singleUser?.data?.is_active),
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            await dispatch(updateUser({ ...values, roles, user_id: id }));
            await dispatch(reset());
        },
    });
    const GetAllParants = async (business_id) => {
        await dispatch(getUserByBusiness(business_id));
        await dispatch(reset());
    };

    const handelChangeBusiness = (e) => {
        formik.values.business_id = e.target.value;
        formik.values.parent = null;
        GetAllParants(e.target.value);
    };

    useEffect(() => {
        if (isError) {
            toast.error(massage);
        }
        if (editSuccess) {
            toast.success("The user Update Succesfully");
        }
        dispatch(reset());
    }, [massage, isError, editSuccess]);

    useEffect(() => {
        formik.values.name = singleUser?.data?.name;
        formik.values.email = singleUser?.data?.email;
        // formik.values.password = singleUser?.data?.password;
        // formik.values.password_confirmation =
        //   singleUser?.data?.password_confirmation;
        formik.values.business_id = Number(singleUser?.data?.business_id);
        formik.values.parent = singleUser?.data?.parent;
        formik.values.ppw = singleUser?.data?.ppw;
        formik.values.phone = singleUser?.data?.phone;
        formik.values.is_active = Boolean(singleUser?.data?.is_active);
        if (formik.values.business_id) GetAllParants(formik.values.business_id);
        setroles(getRolseId);
    }, [singleUser]);

    // Handle Change User Documents
    const [ein, setEin] = useState("");
    const [w9, setW9] = useState("");
    const [certificates, setCertificates] = useState("");
    const [other_path, setOtherPath] = useState("");
    const [other_name, setOtherName] = useState("");

    // Set User Documents Old Documents
    useEffect(() => {
        if (userDocuments) {
            setEin(userDocuments?.ein);
            setW9(userDocuments?.w9);
            setCertificates(userDocuments?.certificates);
            setOtherPath(userDocuments?.other_path);
            setOtherName(userDocuments?.other_name);
        }
    }, [userDocuments]);

    useEffect(() => {
        if (id && editSuccess) {
            const formData = new FormData();
            formData.append("user_id", id);
            formData.append("ein", ein);
            formData.append("w9", w9);
            formData.append("certificates", certificates);
            formData.append("other_path", other_path);
            formData.append("other_name", other_name);

            dispatch(CreateUserDocuments(formData));
        }
    }, [dispatch, id, editSuccess]);

    const handelChangeEIN = (e) => {
        console.log(e.currentTarget.files[0]);
        setEin(e.currentTarget.files[0]);
    };
    const handelChangeW9 = (e) => {
        setW9(e.currentTarget.files[0]);
    };
    const handelChangeCertificates = (e) => {
        setCertificates(e.currentTarget.files[0]);
    };
    const handelChangeOtherPath = (e) => {
        setOtherPath(e.currentTarget.files[0]);
    };

    return (
        <FormContainer>
            <FormHeading>Edit {singleUser?.data?.name} </FormHeading>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="name"
                            name="name"
                            label="name"
                            value={formik.values.name || ""}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.name &&
                                Boolean(formik.errors.name)
                            }
                            helperText={
                                formik.touched.name && formik.errors.name
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="input-with-icon-textfield"
                            name="email"
                            label="Email"
                            value={formik.values.email || ""}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.email &&
                                Boolean(formik.errors.email)
                            }
                            helperText={
                                formik.touched.email && formik.errors.email
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <FormControl fullWidth required={true}>
                            <InputLabel id="demo-multiple-name-label">
                                Role
                            </InputLabel>
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                multiple
                                value={roles || []}
                                onChange={handleChange}
                                required={true}
                                input={<OutlinedInput label="Name" />}
                                // MenuProps={MenuProps}
                            >
                                {ALL_ROLES &&
                                    ALL_ROLES?.map((key) => (
                                        <MenuItem key={key.id} value={key.id}>
                                            {key.title}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <FormControl fullWidth required={true}>
                            <InputLabel id="demo-simple-select-label">
                                Business
                            </InputLabel>
                            <Select
                                required={true}
                                id="business_id"
                                name="business_id"
                                label="Business"
                                value={formik.values.business_id || ""}
                                onChange={handelChangeBusiness}
                            >
                                {ALL_BUSINESS &&
                                    ALL_BUSINESS?.map((key) => (
                                        <MenuItem key={key.id} value={key.id}>
                                            {key.title}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {ALL_USER && ALL_USER.length !== 0 && (
                        <Grid item mb={2} xs={12} md={6}>
                            <FormControl fullWidth>
                                <InputLabel id="demo-simple-select-label">
                                    Parent
                                </InputLabel>
                                <Select
                                    id="parent"
                                    name="parent"
                                    value={formik.values.parent || []}
                                    onChange={formik.handleChange}
                                >
                                    {ALL_USER.map((key) => (
                                        <MenuItem key={key.id} value={key.id}>
                                            {key.name} : {key.email}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}

                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="phone"
                            name="phone"
                            label="Phone"
                            value={formik.values.phone}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.phone &&
                                Boolean(formik.errors.phone)
                            }
                            helperText={
                                formik.touched.phone && formik.errors.phone
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="ppw"
                            name="ppw"
                            type="number"
                            label="ppw "
                            value={formik.values.ppw || ""}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.ppw && Boolean(formik.errors.ppw)
                            }
                            helperText={formik.touched.ppw && formik.errors.ppw}
                        />
                    </Grid>

                    <Grid item mb={2} xs={12} md={6}>
                        <InputLabel>Active ?</InputLabel>
                        <span>No</span>
                        <Switch
                            id="is_active"
                            name="is_active"
                            checked={formik.values.is_active || false}
                            onChange={formik.handleChange}
                            inputProps={{ "aria-label": "controlled" }}
                        />
                        <span>Yes</span>
                    </Grid>

                    <Grid item mb={2} xs={12} md={6}>
                        {userDocuments?.ein && (
                            <DocumentContainer>
                                <a href={userDocuments?.ein} target="_blank">
                                    <Grid container columns={12}>
                                        <Grid item xs={10}>
                                            EIN
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="document-icon"
                                        >
                                            <DocumentScanner />
                                        </Grid>
                                    </Grid>
                                </a>
                            </DocumentContainer>
                        )}
                        <TextField
                            fullWidth
                            id="ein"
                            name="ein"
                            label="EIN"
                            type="file"
                            onChange={(e) => handelChangeEIN(e)}
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        {userDocuments?.w9 && (
                            <DocumentContainer>
                                <a href={userDocuments?.w9} target="_blank">
                                    <Grid container columns={12}>
                                        <Grid item xs={10}>
                                            W9
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="document-icon"
                                        >
                                            <DocumentScanner />
                                        </Grid>
                                    </Grid>
                                </a>
                            </DocumentContainer>
                        )}
                        <TextField
                            fullWidth
                            id="w9"
                            name="w9"
                            label="W9"
                            type="file"
                            onChange={(e) => handelChangeW9(e)}
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        {userDocuments?.certificates && (
                            <DocumentContainer>
                                <a
                                    href={userDocuments?.certificates}
                                    target="_blank"
                                >
                                    <Grid container columns={12}>
                                        <Grid item xs={10}>
                                            Certificates
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="document-icon"
                                        >
                                            <DocumentScanner />
                                        </Grid>
                                    </Grid>
                                </a>
                            </DocumentContainer>
                        )}
                        <TextField
                            fullWidth
                            id="certificates"
                            name="certificates"
                            label="Certificates"
                            type="file"
                            onChange={(e) => handelChangeCertificates(e)}
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        {userDocuments?.other_path && (
                            <DocumentContainer>
                                <a
                                    href={userDocuments?.other_path}
                                    target="_blank"
                                >
                                    <Grid container columns={12}>
                                        <Grid item xs={10}>
                                            {userDocuments?.other_name ||
                                                "Other Document"}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={2}
                                            className="document-icon"
                                        >
                                            <DocumentScanner />
                                        </Grid>
                                    </Grid>
                                </a>
                            </DocumentContainer>
                        )}
                        <TextField
                            fullWidth
                            id="other_path"
                            name="other_path"
                            label="Other File"
                            type="file"
                            onChange={(e) => handelChangeOtherPath(e)}
                        />
                    </Grid>
                </Grid>

                <PrimaryButton fullWidth type="submit">
                    {isLodaing ? "loading..." : "Edit "}
                </PrimaryButton>
            </form>
        </FormContainer>
    );
};
const FormContainer = styled.div`
    padding: 4rem;
    margin: 1rem auto;
    background: var(--white);
    box-shadow: 0 5px 8px 0 var(--box-shadow);
    border-radius: 1rem;
    width: 70%;
`;
const DocumentContainer = styled.div`
    background: var(--light-gray);
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 10px;
    font-weight: bold;
    a {
        color: var(--light-blue);
    }
    .document-icon {
        display: flex;
        justify-content: center;
    }
`;
export default EditUsers;
